import { cssVar } from '@chakra-ui/styled-system';
var $size = cssVar('stepper-indicator-size');
var $iconSize = cssVar('stepper-icon-size');
var $titleFontSize = cssVar('stepper-title-font-size');
var $descFontSize = cssVar('stepper-description-font-size');
var $accentColor = cssVar('stepper-accent-color');

var baseStyle = _ref => {
  var {
    colorScheme: c
  } = _ref;
  return {
    stepper: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '4',
      '&[data-orientation=vertical]': {
        flexDirection: 'column',
        alignItems: 'flex-start'
      },
      '&[data-orientation=horizontal]': {
        flexDirection: 'row',
        alignItems: 'center'
      },
      [$accentColor.variable]: "colors." + c + ".500",
      _dark: {
        [$accentColor.variable]: "colors." + c + ".200"
      }
    },
    title: {
      fontSize: $titleFontSize.reference,
      fontWeight: 'medium'
    },
    description: {
      fontSize: $descFontSize.reference,
      color: 'chakra-subtle-text'
    },
    number: {
      fontSize: $titleFontSize.reference
    },
    step: {
      flexShrink: 0,
      position: 'relative',
      display: 'flex',
      gap: '2',
      '&[data-orientation=horizontal]': {
        alignItems: 'center'
      },
      flex: '1',
      '&:last-of-type:not([data-stretch])': {
        flex: 'initial'
      }
    },
    icon: {
      flexShrink: 0,
      width: $iconSize.reference,
      height: $iconSize.reference
    },
    indicator: {
      flexShrink: 0,
      borderRadius: 'full',
      width: $size.reference,
      height: $size.reference,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&[data-status=active]': {
        borderWidth: '2px',
        borderColor: $accentColor.reference
      },
      '&[data-status=complete]': {
        bg: $accentColor.reference,
        color: 'chakra-inverse-text'
      },
      '&[data-status=incomplete]': {
        borderWidth: '2px'
      }
    },
    separator: {
      bg: 'gray.400',
      flex: '1',
      '&[data-status=complete]': {
        bg: $accentColor.reference
      },
      '&[data-orientation=horizontal]': {
        width: '100%',
        height: '2px',
        marginStart: '2'
      },
      '&[data-orientation=vertical]': {
        width: '2px',
        position: 'absolute',
        height: '100%',
        maxHeight: "calc(100% - " + $size.reference + " - 8px)",
        top: "calc(" + $size.reference + " + 4px)",
        insetStart: "calc(" + $size.reference + " / 2 - 1px)"
      }
    }
  };
};

var defaultProps = {
  size: 'md',
  colorScheme: 'brand'
};
export default {
  baseStyle,
  defaultProps,
  sizes: {
    xs: {
      stepper: {
        [$size.variable]: 'sizes.4',
        [$iconSize.variable]: 'sizes.3',
        [$titleFontSize.variable]: 'fontSizes.xs',
        [$descFontSize.variable]: 'fontSizes.xs'
      }
    },
    sm: {
      stepper: {
        [$size.variable]: 'sizes.6',
        [$iconSize.variable]: 'sizes.4',
        [$titleFontSize.variable]: 'fontSizes.sm',
        [$descFontSize.variable]: 'fontSizes.xs'
      }
    },
    md: {
      stepper: {
        [$size.variable]: 'sizes.8',
        [$iconSize.variable]: 'sizes.5',
        [$titleFontSize.variable]: 'fontSizes.md',
        [$descFontSize.variable]: 'fontSizes.sm'
      }
    },
    lg: {
      stepper: {
        [$size.variable]: 'sizes.10',
        [$iconSize.variable]: 'sizes.6',
        [$titleFontSize.variable]: 'fontSizes.lg',
        [$descFontSize.variable]: 'fontSizes.md'
      }
    }
  }
};
//# sourceMappingURL=Stepper.js.map